// DS: DEV4
import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Trans, useTranslation } from 'react-i18next';
import DollarSignIcon from '@wix/da-ds/pkg/Icons/16x16/DollarSign';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import InfoIcon from '@wix/da-ds/pkg/Icons/24x24/Info';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import TextTooltipOnHover from '../Popover/Preset/TextTooltipOnHover';
import { dollarsToPoints } from '../utils/points';
import { DOLLAR_PRICE_MIN_VALUE, getDollarPriceValidationError, MIN_PRICE_TO_ACCEPT_DOLLARS, } from '../utils/profits';
import { formatDollars } from '../utils/formatting';
import { URLS } from '@wix/da-url';
import { ThemeOptions } from '@wix/da-react-context/pkg/ThemeContext';
import SimpleLink from '../SimpleLink';
import NewIndicatorDot from '../NewIndicatorDot';
import s from './DollarPriceInput.scss';
export var DollarPriceInput = function (_a) {
    var className = _a.className, inputClassName = _a.inputClassName, ftueClassName = _a.ftueClassName, value = _a.value, maxValue = _a.maxValue, coreLevel = _a.coreLevel, showGetCoreBlock = _a.showGetCoreBlock, label = _a.label, profitMargin = _a.profitMargin, errorMessage = _a.errorMessage, showFTUE = _a.showFTUE, _b = _a.showEarnings, showEarningsProp = _b === void 0 ? true : _b, showPointsPrice = _a.showPointsPrice, dropFTUE = _a.dropFTUE, onChange = _a.onChange, refInput = _a.refInput, hidePointsInfo = _a.hidePointsInfo;
    var t = useTranslation().t;
    var _c = useState(null), initialValue = _c[0], setInitialValue = _c[1];
    useEffect(function () {
        setInitialValue(Number(formatValue(value)).toFixed(2));
    }, []);
    var priceInPoints = dollarsToPoints(+value);
    var artistProfit = +value * (1 - profitMargin);
    var artistProfitInPoints = dollarsToPoints(artistProfit);
    var showPointsEarnings = +value > 0 && !errorMessage;
    var showEarnings = showEarningsProp && !isNaN(+value) && !errorMessage && value !== '';
    var formatValue = function (val) { return val.toString().replace(/\.(\d\d).*/, '.$1'); };
    var onFocusHandler = function () {
        showFTUE && dropFTUE();
    };
    var onChangeHandler = function (ev) {
        var newErrorMessage = getDollarPriceValidationError(formatValue(ev.target.value), maxValue, t);
        onChange(ev.target.value, newErrorMessage);
        setInitialValue(null);
    };
    var getFeeTooltipText = function () {
        return (
        /* prettier-ignore */
        React.createElement(Trans, { i18nKey: "common.dollarPriceInput.feeTooltip" },
            "This is how much you\u2019ll earn after the",
            ' ',
            { profitMargin: profitMargin * 100 },
            "% service fee has been deducted."));
    };
    return (React.createElement("div", { className: classnames(s['root'], className) },
        showFTUE && (React.createElement(NewIndicatorDot, { className: classnames(s['new-dot-indicator'], ftueClassName), contentClassName: s['ftue-tooltip'], tooltipMessage: React.createElement(Trans, { i18nKey: "common.dollarPriceInput.FTUEtooltip" },
                React.createElement("strong", null, "New!"),
                " Prices are now in dollars.") })),
        React.createElement("div", { className: s['price-input-line'] },
            React.createElement(TextInput, { id: "dollar-price-input", className: classnames(s['price-input'], inputClassName), value: value ? formatValue(initialValue !== null && initialValue !== void 0 ? initialValue : value) : '', validationResult: errorMessage ? 'error' : undefined, details: errorMessage, onFocus: onFocusHandler, onChange: onChangeHandler, name: "dollarPriceInput", prefix: React.createElement(DollarSignIcon, null), label: label || t('common.dollarPriceInput.inputLabel'), min: DOLLAR_PRICE_MIN_VALUE, max: maxValue, maxLength: 8, autoComplete: "off", ref: refInput }),
            showPointsPrice && (React.createElement("span", { className: s['points-price'] },
                "\u00A0/ ",
                priceInPoints,
                ' ',
                t('common.points', {
                    count: priceInPoints,
                }),
                ' '))),
        showEarnings && (React.createElement("div", { className: s['earnings-line'] }, !!value && (React.createElement(React.Fragment, null,
            React.createElement("span", { className: s['your-earnings-label'] },
                t('common.pointsInput.yourEarnings'),
                ":",
                ' '),
            React.createElement("span", { className: s['your-earnings-value'] },
                React.createElement(React.Fragment, null,
                    "\u00A0",
                    formatDollars(artistProfit),
                    showPointsEarnings && (React.createElement(React.Fragment, null,
                        "\u00A0/ ",
                        artistProfitInPoints,
                        ' ',
                        t('common.points', {
                            count: artistProfitInPoints,
                        }),
                        ' ')))),
            React.createElement(TextTooltipOnHover, { placement: "top", tooltipText: React.createElement("div", null, getFeeTooltipText()), forceTheme: ThemeOptions.LIGHT },
                React.createElement(InfoIcon, { size: IconSize.SMALL, className: s['icon'] })))))),
        showPointsEarnings && !hidePointsInfo && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: s['points-only-warning'] }, t('common.dollarPriceInput.warning.pointsOnly', {
                value: MIN_PRICE_TO_ACCEPT_DOLLARS,
            })),
            React.createElement("div", { className: s['what-are-points-line'] }, !!value && (React.createElement(SimpleLink, { target: "_blank", href: URLS.ABOUT_POINTS, className: s['what-are-points'], size: "small" }, t('common.faq.whatArePoints')))))),
        showGetCoreBlock && (React.createElement("div", { className: s['get-core-block'] },
            React.createElement(Trans, { i18nKey: "common.dollarPriceInput.cta.getCoreForHigherPrice" },
                "Get ",
                React.createElement("a", { href: URLS.CORE_MEMBERSHIP }, "CORE"),
                " to set a higher price")))));
};
DollarPriceInput.displayName = 'DollarPriceInput';
export default DollarPriceInput;
//# sourceMappingURL=DollarPriceInput.js.map